import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { showEnter } from "@dmms/shared/animations/animation";
import { IFormFieldFilter } from "@models/form/base-config";

@Component({
  selector: "ui-filter-dialog",
  templateUrl: "./ui-filter-dialog.component.html",
  styleUrl: "./ui-filter-dialog.component.scss",
  standalone: false,
  animations: [showEnter],
})
export class UIFilterDialogComponent implements AfterViewInit {
  @Input() fields: IFormFieldFilter<any>[] = [];
  @Input() form: FormGroup;
  @Input() hideResetBtn: boolean = false;
  @Input() popoverCssClass?: string;
  @Output() closeEmit = new EventEmitter<void>();
  @Output() clearEmit = new EventEmitter<void>();
  @Output() searchEmit = new EventEmitter<void>();

  ngAfterViewInit(): void {
    const filterPopover = document.querySelector("ngb-popover-window");
    const overlayContainer = document.querySelector(".cdk-overlay-container");

    if (
      overlayContainer?.parentNode === document.body &&
      filterPopover?.parentNode === document.body
    ) {
      overlayContainer.parentNode.insertBefore(filterPopover, overlayContainer);
    }
  }

  clear(): void {
    this.clearEmit.emit();
  }

  search(): void {
    this.searchEmit.emit();
  }
}
